import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import {LocalStorageServiceProvider} from '../../providers/local-storage-service/local-storage-service'
import { LoadingController, Loading } from 'ionic-angular';
import { Events } from 'ionic-angular';

export let TRANSACTION_CREATED_EVENT = "transaction:created";
export let TRANSACTION_UPDATED_EVENT = "transaction:updated";

@Component({
    selector: 'page-transaction-form',
    templateUrl: 'transaction-form.html',
})
export class TransactionAddPage {

    transaction = {
        date: new Date().toISOString()
    };

    categories: any;

    user_id: String
    account_id: String

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public server: ServerProvider, public localStorage: LocalStorageServiceProvider,
                public loadingCtrl: LoadingController, public events: Events) {

        this.user_id = this.navParams.get("user_id");
        this.account_id = this.navParams.get("account_id")

        this.categories = localStorage.getCategories();
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad TransactionFormPage');
    }

    save(transaction_form) {

        let loader = this.loadingCtrl.create({
            content: "Bitte warten...",
            duration: 5000
        });
        loader.present()
        this.server.createTransaction(this.user_id, this.account_id, transaction_form).subscribe(
            data=>{
                console.log(this.events)
                this.events.publish(TRANSACTION_CREATED_EVENT, data.json());
                loader.dismiss()
                this.navCtrl.pop()
            },
            error=>{
                loader.dismiss()
            }
        )
    }

    abort() {
        this.navCtrl.pop()
    }

}



// WEBPACK FOOTER //
// ./src/pages/transaction-form/transaction-form-add.ts